import React from "react";
import PropTypes from "prop-types";

const GameHeader = ({ teamData, isRowHeader, sportId }) => {
  // For movies: header_type 2 = text, 1 = image with logo_url
  // For sports: type 2 = text only, type 4 = text + image, otherwise image only
  const isMovies = parseInt(sportId) === 12;
  const displayText = teamData.display || teamData.text || teamData.name;
  const imageUrl = teamData.logo_url || teamData.img_url;

  // Type 2 = text only
  const isTextOnly = isMovies
    ? (teamData.header_type === 2 || !teamData.logo_url)
    : (teamData.type === 2);

  // Type 4 = text + image (for all sports)
  const isTextAndImage = isMovies
    ? false // Movies handle text display differently
    : (teamData.type == 4);

  return (
    <div className={isRowHeader ? "row-header" : "header"}>
      {isTextOnly ? (
        <p className={"rowHeaderText"}>{displayText}</p>
      ) : isTextAndImage ? (
        <div style={{ textAlign: "center" }}>
          <p className={"rowHeaderText"}>{displayText}</p>
          <img
            src={imageUrl}
            alt={displayText}
            className={"team-logo"}
          />
        </div>
      ) : (
        <div style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
          {isMovies && (
            <p className={"rowHeaderText"} style={{ fontSize: "11px", margin: 0, fontWeight: "600" }}>
              {displayText}
            </p>
          )}
          <img
            src={imageUrl}
            alt={displayText}
            className={"team-logo"}
          />
        </div>
      )}
    </div>
  );
};

GameHeader.propTypes = {
  teamData: PropTypes.object.isRequired,
  isRowHeader: PropTypes.bool.isRequired,
  sportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const ColumnHeader = ({ teamData, sportId }) => GameHeader({ teamData, isRowHeader: false, sportId });
const RowHeader = ({ teamData, sportId }) => GameHeader({ teamData, isRowHeader: true, sportId });

export { ColumnHeader, RowHeader };
